<h2 mat-dialog-title fxLayout="row" fxLayoutAlign="start center">
    Comment
</h2>

<mat-dialog-content style="padding: 10px;" [formGroup]="formGroup">
    <lgd-textarea controlName="comment">
    </lgd-textarea>

    <busy-indicator *ngIf="isProcessing" [page]="true"></busy-indicator>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <command-bar [commands]="commands">
    </command-bar>
</mat-dialog-actions>